import {ServerResponse} from '@shared/interfaces';

export const serverResponseToast = (toast: any, response: ServerResponse) => {
  const duration = response.subtext ? 13000 : 7000;
  toast.response(response.type, response.message, response.subtext, duration);
};

/**
 * Obj is the parent object and **level** is the immediate child of **obj**
 * Rest is any deeper keys that belong to each consecutive parent.
 * <pre>
 * E.g.
 * var test = {level1:{level2:{level3:'level3'}} };
 * checkNested(test, 'level1', 'level2', 'level3'); // Result: true
 * </pre>
 * @param obj Parent object
 * @param level Child of parent object
 * @param rest Consecutive children of previous parent
 */
export const checkNested = (obj: any, level?: any, ...rest: any) => {
  if (obj === undefined || obj === null)
    return false;
  if (rest.length === 0 && obj.hasOwnProperty(level) && obj[level] != null)
    return true;
  return checkNested(obj[level], ...rest);
};

export const getNested = (obj: any, ...args) => {
  return args.reduce((_obj, level) => _obj && _obj[level], obj);
};

export const camelize = (str: string) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
};

export const roundToTwo = (num: any, roundVal = 2) => {
  return +(Math.round((num + `e+${roundVal}`) as any) + `e-${roundVal}`);
};
